<!-- <div class="error-wrapper">
    <app-alert-message *ngIf="true" type="ai-error" mb="24px">AI Service is experiencing delays.  Try again in a moment.</app-alert-message>
</div> -->

<div inputWrapper class="agent-keyboard-wrapper"
    [ngClass]="{'keyboard-focused': isKeyboardFocused, 'keyboard-fixed': currentConversation.length > 0}">

    <div class="action-button" (click)="onSendQuery()"
        [ngClass]="{ 'active' : query.length > 1 && query.length < 2000}">
        <app-svg-loader url="assets/svg/circle-arrow-up.svg"></app-svg-loader>
    </div>

    <app-base-input id="input-el" [placeholder]="!isProcessingQuery ? getInputPlaceholder() : dynamicStatusText"
        [(ngModel)]="query" (focusEvent)="onFocus()" (blurEvent)="onBlur()" (onEnter)="onSendQuery()" isFluid="true"
        hasIcon="true" autocomplete="off"></app-base-input>

    <div *ngIf="isKeyboardFocused" class="input-backdrop" (click)="onBackdropClick()"></div>

</div>